import { Injectable } from '@angular/core';
import { NotificationService as CarbonNotificationService } from 'carbon-components-angular';

@Injectable()
export class NoteService {

	// currentNote is for supporting the legacy note system of the banner at the top, and will only be used if there's no note target element found on the page
	currentNote: any = {};

	clearSelfAfterSeconds = 8;

	constructor(protected carbonNotificationService: CarbonNotificationService) {}

	displayError(msg: string, clean: boolean = false, actions: NoteAction[] = []) {
		this.showNote(msg, 'error', clean, actions);
	}

	displaySuccess(msg: string, clean: boolean = true, actions: NoteAction[] = []) {
		this.showNote(msg, 'success', clean, actions);
	}

	displayInfo(msg: string, clean: boolean = true, actions: NoteAction[] = []) {
		this.showNote(msg, 'info', clean, actions);
	}

	displayWarning(msg: string, clean: boolean = true, actions: NoteAction[] = []) {
		this.showNote(msg, 'warning', clean, actions);
	}

	showNote(msg: string, type: string, clearSelf: boolean, actions: NoteAction[]) {
		// use note for toast if exists, otherwise fall back to legacy note banner (used for login page)
		if (document.getElementById('note-toast-target') !== null) {
			// have to pass in a callback to Note action, but needs reference to instance to close itself
			// therefore, pass in an object reference with null callback first, then update that callback after Note is created
			let noteInstanceData = { note: null, closeCallback: null };
			let actionsForToast = actions.map(x => { return { text: x.text, click: () => { x.callback(); noteInstanceData.closeCallback(); }}});

			noteInstanceData.note = this.carbonNotificationService.showNotification({
				type: type,
				title: '',
				message: msg,
				target: '#note-toast-target',
				duration: clearSelf ? (this.clearSelfAfterSeconds * 1000) : undefined,
				actions: actionsForToast
			});

			// update note action callback here to close itself when action is clicked
			noteInstanceData.closeCallback = () => this.carbonNotificationService.close(noteInstanceData.note);
		} else {
			// legacy note system
			this.currentNote = {
				message: msg,
				type: type,
				active: true,
				actions: actions
			};
			if (clearSelf) {
				setTimeout(() => this.clearCurrentNote(), 6000);
			}
		}
	}

	// clears the legacy note banner
	clearCurrentNote(immediate: boolean = false) {
		if (immediate) {
			this.currentNote = {};
			return;
		}

		this.currentNote['active'] = false;
		const self = this;
		const delay = setTimeout(function () {
			self.currentNote = {};
		}, 500);
	}
}

interface NoteAction {
	text: string;
	callback: () => void;
}
